import { Injectable, computed, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { adminUserDtos, userDtos } from '@vectronic/openApi-admin';
import { LoggedInUserService } from '@vectronic/shared/data-access/logged-in-user';
import { capitalize } from 'es-toolkit/compat';
import { UsersRestService } from './REST/users.rest.service';

interface UsersState {
  users: userDtos.UserAccountLight[];
  salesUsers: adminUserDtos.User[];
  loaded: boolean;
  error: string | null;
}
@Injectable({ providedIn: 'root' })
export class UsersService {
  private usersRestService = inject(UsersRestService);
  private loggedInUserService = inject(LoggedInUserService);

  //state
  private state = signal<UsersState>({
    users: [],
    salesUsers: [],
    loaded: false,
    error: null,
  });

  // selectors
  users = computed(() => this.state().users);
  sales = computed(() => this.state().salesUsers);

  // sources
  #usersLoaded = this.usersRestService.getAllUsers();
  #salesLoaded = this.usersRestService.getSalesUsers();

  constructor() {
    // reducers
    this.#usersLoaded
      .pipe(takeUntilDestroyed())
      .subscribe((users) => this.state.update((state) => ({ ...state, users })));

    this.#salesLoaded.pipe(takeUntilDestroyed()).subscribe((users) =>
      this.state.update((state) => ({
        ...state,
        salesUsers: [
          // add logged in user on first position (mock if does not exist)
          users.find((user) => user.email === this.loggedInUserService.username()) ?? {
            email: this.loggedInUserService.username(),
            firstName: capitalize(this.loggedInUserService.username().split('@')[0]),
            lastName: '',
            initials: this.loggedInUserService.username().split('@')[0].slice(0, 2).toUpperCase(),
          },
          ...users.filter((user) => user.email !== this.loggedInUserService.username()),
        ],
      })),
    );
    // effects
  }
}
